import React, { FC } from "react";
import ApolloAuthProvider from "./apollo_auth";
import { NotificationProvider } from "./notification";
import ScrollToHash from "common/base/ScrollToHash";
import { colorScheme } from "utils";
import { ConfigProvider } from "antd";
import { ThemeProvider } from "styled-components";

export const AppProviders:FC<{children: React.ReactNode}> = ({children}) => {
    const colors = colorScheme.light;
    return (
        <ConfigProvider theme={{ token: { 
            // colorPrimary: colors.primary,
            // "colorText": colors.primary,
            // "colorBgElevated": colors.background,
            // "colorBorder": "#333537",
        } }}>
            <ThemeProvider {...{ theme: { colors } }}>
                <NotificationProvider>
                    <ApolloAuthProvider>
                        <ScrollToHash/>
                        {children}
                    </ApolloAuthProvider>
                </NotificationProvider>
            </ThemeProvider>
        </ConfigProvider>
    )
}